<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <!-- <nav-bar></nav-bar> -->
          <template>
            <el-button
              type="default"
              icon="el-icon-download"
              style="margin-bottom: 10px"
              @click="exportDeviceList()"
              :loading="loading"
              v-if="hasExportAuth"
              >{{ $t("button.exportAll") }}</el-button
            >
            <a
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              @click="backKPI"
              >{{ $t("el.pageHeader.title") }}</a
            >
            <div class="tableDiv">
            <el-table
              :data="tableData1"
              stripe
              style="width: 100%"
              :empty-text="$t('desc.noData')"
            >
              <el-table-column
                type="index"
                :label="$t('title.serialNumber')"
                width="60"
                fixed="left"
              >
              </el-table-column>
              <el-table-column
                prop="dsn"
                :label="$t('desc.airCompressorSN')"
                width="170"
                fixed="left"
              >
               <template slot-scope="scope">
                  <label class="span-line" style="color:#00C9FF;cursor:pointer" @click="openDevice(true, scope.row)">{{scope.row.dsn}}</label>
                </template>
              </el-table-column>
              <el-table-column
                prop="modelId"
                :label="$t('title.airCompressorType')"
                width="250"
              >
              </el-table-column>

              <el-table-column
                prop="customerName"
                :label="$t('desc.customer')"
                width="300"
              >
                <template slot-scope="scope">
                  {{ containTranslate(scope.row.customerName) }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                  prop="customerCode"
                  label="客户代码"
                  width="100"
                >
                </el-table-column> -->
              <!-- <el-table-column
                prop="stationName"
                :label="$t('desc.airCompressionStation')"
                width="150"
              >
              </el-table-column> -->
              <el-table-column
                prop="serviceType"
                :label="$t('title.airCompressorService')"
                width="250"
              >
              </el-table-column>
              <el-table-column
                prop="ccn"
                :label="$t('title.controlsCCN')"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="gsn"
                :label="$t('desc.gatewaySN')"
                width="150"
              >
              </el-table-column>
              <!-- <el-table-column
                prop="lastUseRate"
                :label="$t('title.UtilizationRate')"
                width="120"
              >
              </el-table-column> -->
              <!-- <el-table-column
                prop="beatStatusName"
                :label="$t('title.gatewaystatus')"
                width="200"
              >
                <template slot-scope="scope">
                  {{$t('gatewayState.'+scope.row.beatStatusName)}}
                </template>
              </el-table-column> -->
              <el-table-column
                prop="gatewayState"
                :label="$t('title.isBinding')"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="registerTime"
                :label="$t('title.registerTime')"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="lastBeatTime"
                :label="$t('title.lastBeatTime')"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="installMethod"
                :label="$t('acronym.installMethod')"
                width="200"
              >
                <template slot-scope="scope">
                  <label v-if="scope.row.installMethod == 'factory'">{{
                    $t("acronym.plantErection")
                  }}</label>
                  <label v-else-if="scope.row.installMethod == 'scene'">{{
                    $t("acronym.fieldInstallation")
                  }}</label>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              :page-size="pagination.pageSize"
              :page-sizes="[10, 20, 50]"
              :current-page.sync="pagination.current"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="prev, pager, next,sizes"
              :total="pagination.totalPage"
              style="text-align: center; margin-top: 10px"
            >
            </el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <monitor-deviceInfo-Dialog
      ref="deviceInfoRef"
      :dialogClient="dialogDevice"
      :title="deviceTitle"
      :DeviceInfo="DeviceInfoShow"
      :CustomerInfo="CustomerInfo"
      :gatherOption="ccnGatherOption"
      :ccnCodeList222="ccnCodeList222"
      :activeLang="activeLang"
      :isDingOrBian="isDingOrBian"
      :echartID="echartID"
      :echartIDHistory="echartIDHistory"
      :maintainList="maintainList"
      :IsShowSensitive="IsShowSensitive"
      :UseRateData="UseRateData"
      @getMonitorHistoryByGsn="getMonitorHistoryByGsn"
      @dialogVisibleEvent="openDevice"
      @openCcnTable="openCcnTable"
      @getRealData="getRealData"
      @changeCode="changeCode"
      @openMaintain="openMaintainDialog"
    >
    </monitor-deviceInfo-Dialog>
    <monitor-ccn-table
      :dialogClient="dialogDeviceCCN"
      :title="tableTitle"
      :tableCCN="tableCCN"
      :tableType="tableType"
      @dialogVisibleEvent="openCcnTable"
    >
    </monitor-ccn-table>

    <monitor-maintain-dialog
      :dialogClient="dialogMaintain"
      :title="maintainTitle"
      :serviceform="serviceform"
      :tableService="tableService"
      @dialogVisibleEvent="openMaintainDialog"
    >
    </monitor-maintain-dialog>
  </div>
</template>
<script>
import {
  authOperationCheck,
  getMonitorHistoryByGsn,
  exportExcelNew,
  GetKPIStatDeviceList,
  GetExportKPIStatDeviceList,
} from "../../api/api";
import deviceDialogComponent from "../../components/content/maintabber/CompressorDialog";
import gatewayRegisterComponent from "../../components/content/maintabber/GatewayRegisterDialog";
import monitorDeviceInfoDialog from "../../components/content/monitor/MonitorDeviceInfoDialog";
import monitorCcnTable from "../../components/content/monitor/MonitorCcnTable";
import monitorMaintainDialog from "../../components/content/monitor/MonitorMaintainDialog";
import agencyImportComponent from "../../components/content/maintabber/ExportExcelFile";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { monitorMixin } from "../../mixins/monitorMixin";

export default {
  name: "index",
  mixins: [monitorMixin],
  components: {
    "device-dialog": deviceDialogComponent,
    "gateway-dialog": gatewayRegisterComponent,
    "monitor-deviceInfo-Dialog": monitorDeviceInfoDialog,
    "monitor-ccn-table": monitorCcnTable,
    "import-dialog": agencyImportComponent,
    "monitor-maintain-dialog": monitorMaintainDialog,
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  data() {
    return {
      tableType:"",
      loading: false,
      gsnStateList: {
        0: "未连接",
        1: "正常",
        2: "警告",
        "-1": "脱机",
      },
      hasExportAuth: false,
      tableData1: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      translateList: {
        定期保养: "desc.pmPureLabor",
        一次性保养: "desc.oneTimePM",
        延长保修: "desc.extendWarranty",
        工厂保内: "desc.factoryWarranty",
        其他: "desc.other",
      },
      bondStatusTraslate: {
        已绑定: "title.Bound",
        未绑定: "title.Unbound",
      },
    };
  },
  created: function () {
    this.authOperation("Device");
  },
  async mounted() {
    this.getDeviceList();
    this.getGatherOption();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasExportAuth = res.hasExportAuth;
    },
    getDeviceList(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        bigRegionId: this.$route.query.bigRegionId,
        customerCenterId: this.$route.query.customerCenterId,
        productLine: this.$route.query.productLine,
        type: this.$route.query.type,
        Language: this.activeLang,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      GetKPIStatDeviceList(postData)
        .then((res) => {
          let data = res.result.items;
          this.pagination.totalPage = res.result.totalCount;
          that.tableData1 = data;
          for (let index = 0; index < data.length; index++) {
            that.tableData1[index].beatStatusName =
              that.gsnStateList[that.tableData1[index].beatStatus];
            that.tableData1[index].lastUseRate =
              that.tableData1[index].lastUseRate + "%";
            if (that.translateList[that.tableData1[index].serviceType]) {
              that.tableData1[index].serviceType = that.$t(
                that.translateList[that.tableData1[index].serviceType]
              );
            }
            that.tableData1[index].gatewayState = that.$t(
              that.bondStatusTraslate[that.tableData1[index].gatewayState]
            );
          }
        })
        .catch((err) => {});
    },
    exportDeviceList() {
      let that = this;
      that.loading = true;
      // var data = {
      //   Ccn: ccn,
      //   Version: version,
      // };
      // var headers = [
      //   { key: "dsn", title: "空压机SN号" },
      //   { key: "modelId", title: "空压机型号" },
      //   { key: "customerName", title: "客户" },
      //   { key: "stationName", title: "空压站名称" },
      //   { key: "serviceType", title: "空压机服务类型" },
      //   { key: "ccn", title: "控制器软件CCN号" },
      //   { key: "gsn", title: "网关SN号" },
      //   { key: "lastUseRate", title: "利用率" },
      //   { key: "beatStatusName", title: "网关状态" },
      //   { key: "gatewayState", title: "绑定状态" },
      //   { key: "registerTime", title: "绑定时间" },
      // ];
      var exportData = [
        [
          "空压机SN号",
          "空压机型号",
          "客户",
          "空压站名称",
          "空压机服务类型",
          "控制器软件CCN号",
          "网关SN号",
          "利用率",
          "网关状态",
          "绑定状态",
          "绑定时间",
          "安装方式",
        ],
      ];

      var fileName = that.$t("desc.equipmentRegistrationList")+".csv";
      let postData = {
        bigRegionId: this.$route.query.bigRegionId,
        customerCenterId: this.$route.query.customerCenterId,
        productLine: this.$route.query.productLine,
        type: this.$route.query.type,
        Language: this.activeLang,
        SkipCount: 0,
        MaxResultCount: 100000,
      };
      GetExportKPIStatDeviceList(postData).then((res) => {
        if (res.result) {
          let data = res.result.items;
          // this.pagination.totalPage = res.result.totalCount;
          for (let index = 0; index < data.length; index++) {
            data[index].beatStatusName =
              that.gsnStateList[data[index].beatStatus];
            data[index].lastUseRate = data[index].lastUseRate + "%";
            if (that.translateList[data[index].serviceType]) {
              data[index].serviceType = that.$t(
                that.translateList[data[index].serviceType]
              );
            }
            data[index].gatewayState = that.$t(
              that.bondStatusTraslate[data[index].gatewayState]
            );
          }
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          let header = [
            that.$t('desc.airCompressorSN'),
            that.$t('title.airCompressorType'),
            that.$t('desc.customer'),
            that.$t('title.airCompressorService'),
            that.$t('title.controlsCCN'),
            that.$t('desc.gatewaySN'),
            that.$t('desc.UtilizationRate'),
            that.$t('title.gatewaystatus'),
            that.$t('title.isBinding'),
            that.$t('title.registerTime'),
            that.$t('acronym.installMethod'),
          ];
          let exportContent = new Array();
          dataSource.forEach((item) => {
            let rowData = new Object();
            rowData = {
              dsn: item.dsn,
              modelId: item.modelId,
              customerName: this.containTranslate(item.customerName),
              serviceType: item.serviceType,
              ccn: item.ccn,
              gsn: item.gsn,
              lastUseRate: item.lastUseRate,
              beatStatusName: that.$t("gatewayState." +item.beatStatusName),
              gatewayState: item.gatewayState,
              registerTime: item.registerTime,
              installMethod: item.installMethod === ""
                ? ""
                : item.installMethod === "factory"
                ? that.$t("acronym.plantErection")
                : that.$t("acronym.fieldInstallation"),
            };
            exportContent.push(rowData);
          });
          exportExcelNew({header},fileName,exportContent)
          that.loading = false;
        }
      });
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDeviceList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDeviceList();
    },
    backKPI() {
      this.$router.push({
        name: "/report/installKPI",
      });
    },
    containTranslate(str) {
      let containArr = ['直管', '经销商', '服务经销商', '中间商', '其他'];
      let result="";
      containArr.forEach(element=>{
        if (str.indexOf(element) > -1) {
          let displayStr = this.$t('desc.'+element);
          result = str.replace(element,displayStr);
        }
      });
      return result;
    }
  },
};
</script>
<style scoped>
.infodiv {
  margin-top: 5px;
  border: 1px solid #d2d2d2;
  padding: 10px;
  border-radius: 5px;
  background-color: #f3f3f3;
}
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
<style scope>
.el-table__fixed-right {
  right: 0px !important;
}
</style>
<style  scope>
.NoRaidoLabel .el-table__row .el-radio__label {
  display: none;
}
</style>
 